import React from 'react';
import { Helmet } from 'react-helmet-async';

interface SEOProps {
    title?: string;
    description?: string;
    keywords?: string;
    ogImage?: string;
    canonical?: string;
    type?: string;
}

export const SEO: React.FC<SEOProps> = ({
    title = 'Refine Studio | Professional Web Development & Design Services',
    description = 'Transform your business with powerful web solutions. Expert website development, redesign, professional catalogues, and digital services for global reach.',
    keywords = 'web development, website design, professional web design, custom website development, website redesign, digital transformation, e-commerce development, SEO services, web development agency',
    ogImage = 'https://refinestudio.vercel.app/og-image.jpg',
    canonical,
    type = 'website'
}) => {
    const siteUrl = 'https://refinestudio.vercel.app';
    const fullCanonical = canonical || siteUrl;

    return (
        <Helmet>
            {/* Primary Meta Tags */}
            <title>{title}</title>
            <meta name="title" content={title} />
            <meta name="description" content={description} />
            <meta name="keywords" content={keywords} />

            {/* Canonical URL */}
            <link rel="canonical" href={fullCanonical} />

            {/* Open Graph / Facebook */}
            <meta property="og:type" content={type} />
            <meta property="og:url" content={fullCanonical} />
            <meta property="og:title" content={title} />
            <meta property="og:description" content={description} />
            <meta property="og:image" content={ogImage} />
            <meta property="og:site_name" content="Refine Studio" />

            {/* Twitter */}
            <meta property="twitter:card" content="summary_large_image" />
            <meta property="twitter:url" content={fullCanonical} />
            <meta property="twitter:title" content={title} />
            <meta property="twitter:description" content={description} />
            <meta property="twitter:image" content={ogImage} />

            {/* Additional SEO */}
            <meta name="robots" content="index, follow" />
            <meta name="language" content="English" />
            <meta name="revisit-after" content="7 days" />
            <meta name="author" content="Refine Studio" />
        </Helmet>
    );
};
